import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Modal } from 'flowbite-react';
import { style } from "./ModalSignUp";

import ErrorWrapper from "./ErrorWrapper";
import Loading from "./Loading";

import MyAuthContext from "../context/AuthContext";

const ModalPasswordRecover = ({ isModalPasswordRecoverOpen, setIsModalPasswordRecoverOpen, setIsModalLoginOpen, setSuccessAlert }) => {
    const { recoverPasswordGenerate, loading } = useContext(MyAuthContext);

    const [error, setError] = useState({ "error": false, "message": "" });

    const schema = yup.object().shape({
        userEmail: yup.string().email("El correo es inválido").required("El correo es requerido")
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        setError({"error": false, "message": ""});
        const res = await recoverPasswordGenerate(data);
        if(res.error){
            setError({"error": true, "message": res.response});
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 10000);
        }else{
            //show alert
            setSuccessAlert("Se ha enviado un correo a tu cuenta de correo electrónico para recuperar tu contraseña");
            setTimeout(() => {
                setSuccessAlert(null);
            }, 10000);
            closeModal();
        }
    }

    const closeModal = () => {
        setIsModalPasswordRecoverOpen(false);
        reset();
    }

    return (
        <Modal show={isModalPasswordRecoverOpen} style={{ height: "100%" }} position="center" size="md">
            <div class="flex flex-col items-center justify-center mx-auto lg:w-[100%]">
                <div className='w-full bg-white rounded-lg shadow'>
                    <div class="p-6 space-y-4">
                        <div class="flex flex-row py-3">
                            <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">Recuperar contraseña</h1>
                            <button className='absolute font-bold top-2 right-3' onClick={() => closeModal()}>x</button>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)} class="space-y-4">
                            <div class="relative z-0 mb-6 w-full group">
                                <input type="email" {...register("userEmail")} class={style.formInput} placeholder=" " />
                                <label class={style.formLabel}>Correo Electrónico</label>
                                <ErrorWrapper error={errors.userEmail?.message} />
                            </div>

                            <div className='text-center w-full'>
                                {error.error && <ErrorWrapper error={error.message} />}
                            </div>
                            {loading ? <Loading isLoading={true} /> : <button type="submit" class="flex mx-auto bg-gray-300 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm w-full w-auto px-5 py-2.5 text-center">Recuperar contraseña</button>}
                            
                            <p class="text-sm font-light text-gray-500">
                                ¿Deseas <button type="button" onClick={() => { setIsModalLoginOpen(true); closeModal() }} class="font-medium text-teal-500 hover:underline">Iniciar sesión?</button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalPasswordRecover;